import { GetPaymentAggregateResponse } from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';

const WIX_PAYMENT_PROVIDER_ID = 'com.wix.wixpay.us';

export function isWixPaymentProviderSupported(paymentAggregators: GetPaymentAggregateResponse): boolean {
  const providers = paymentAggregators?.providers || [];

  return providers.some((provider) => provider.id === WIX_PAYMENT_PROVIDER_ID);
}
